module.exports = __webpack_public_path__ + "static/media/17434630_10154599584208990_3609987548379694630_o.52a55cc6.jpg";